import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import initialData from "./initial-data";
import Column from "./Column";
import "./App.css";
import { useQuery } from "react-query";
import { fetchData } from "../network/apiService";

const SupportSummary = ({ consumerId }) => {
  const [data, setData] = useState(initialData);
  const [issues, setIssues] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const data1 = await fetchData(consumerId);
        setIssues(data1?.data?.issues || []);
      } catch (error) {
        setIssues([]);
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData1();
  }, [consumerId]);
  function getDescription(document) {
    // Extract the JSON string from the content structure
    const jsonString = document?.content?.[0]?.content?.[0]?.text || "";
    let parsedObject = "";
    try {
      // Parse the JSON string into an object
      const parsedObject = JSON.parse(jsonString);
      if (parsedObject && typeof parsedObject === "object") {
        return parsedObject.description || "";
      }
      return jsonString;
  
    } catch (error) {
      console.error("Error parsing JSON string:", error);
    }
    // Return the description and tlinks
    return parsedObject;
  }

  const issuesArray = issues.map((item) => {
    return {
      id: item.key,
      key: item.key,
      label: [item.fields.labels],
      currentStatus: item.fields.status.name,
      issueType: item.fields.issuetype.name,
      created: item.fields.created,
      summary: item.fields.summary,
      description: getDescription(item.fields.description)
    };
  });

  const getKeysByStatus = (data, status) => {
    return data
      .filter((issue) => {
        return status.includes(issue.currentStatus);
      })
      .map((issue) => {
        return issue.key;
      });
  };
  const knownReviewStatuses =["Waiting for support","Review"];
  const knownResolvedStatuses = ["Canceled", "Closed", "Resolved","Done"];
  const keysInReview = getKeysByStatus(issuesArray, knownReviewStatuses);
  const keysInResolved = getKeysByStatus(issuesArray, knownResolvedStatuses);

  const keysInProgress = issuesArray
    .filter((issue) => {
      return (
        !knownReviewStatuses.includes(issue.currentStatus) &&
        !knownResolvedStatuses.includes(issue.currentStatus)
      );
    })
    .map((issue) => {
      return issue.key;
    });

  const onDragEnd = (result) => {
    const { destination, source, draggableId } = result;

    if (!destination) {
      return;
    }

    if (
      destination.droppableId === source.droppableId &&
      destination.index === source.index
    ) {
      return;
    }

    const start = data.columns[source.droppableId];
    const finish = data.columns[destination.droppableId];

    if (start === finish) {
      const newTaskIds = Array.from(start.taskIds);
      newTaskIds.splice(source.index, 1);
      newTaskIds.splice(destination.index, 0, draggableId);

      const newColumn = {
        ...start,
        taskIds: newTaskIds
      };

      const newData = {
        ...data,
        columns: {
          ...data.columns,
          [newColumn.id]: newColumn
        }
      };

      setData(newData);
      return;
    }

    // Moving from one list to another
    const startTaskIds = Array.from(start.taskIds);
    startTaskIds.splice(source.index, 1);
    const newStart = {
      ...start,
      taskIds: startTaskIds
    };

    const finishTaskIds = Array.from(finish.taskIds);
    finishTaskIds.splice(destination.index, 0, draggableId);
    const newFinish = {
      ...finish,
      taskIds: finishTaskIds
    };

    const newData = {
      ...data,
      columns: {
        ...data.columns,
        [newStart.id]: newStart,
        [newFinish.id]: newFinish
      }
    };

    setData(newData);
  };

  return (
    <div style={{ borderTopLeftRadius: "10px", border: "solid 1px #e1e1e1" }}>
      <div
        style={{
          borderTopLeftRadius: "10px",
          background: "linear-gradient(to left, #156ab3, #0f4c81 -15%)",
          height: "60px",
          padding: "10px"
        }}
      >
        <img
          src='https://cdn.roemanu.io/los/mmtc/emails/mmtc-logo.jpg'
          alt='logo'
          style={{
            width: "auto",
            height: "39px",
            marginLeft: "10px"
          }}
        />
      </div>
      <h1
        style={{
          fontSize: "20px",
          padding: "20px",
          fontWeight: "500",
          textAlign: "left"
        }}
      >
        Ticket Tracker
      </h1>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className='App'>
          {data.columnOrder.map((columnId) => {
            const column = data.columns[columnId];
            if (column.title === "Submitted") {
              column.taskIds = keysInReview;
            } else if (column.title === "In Progress") {
              column.taskIds = keysInProgress;
            } else if (column.title === "Resolved") {
              column.taskIds = keysInResolved;
            }

            const filteredTasks = issuesArray.filter((task) => {
              return column.taskIds.includes(task.id);
            });
            const tasks = filteredTasks;

            return <Column key={column.id} column={column} tasks={tasks} />;
          })}
        </div>
      </DragDropContext>
    </div>
  );
};

export { SupportSummary };
export default SupportSummary;
